// @flow
import _ from 'lodash';

import ApiManager from './ApiManager';

// -- contants
import APIEndpoints from '../constants/APIEndpoints';

// -- entities
import RestaurantMultipart from '../entities/RestaurantMultipart';
import Restaurant from '../entities/Restaurant';
import RestaurantsList from '../entities/RestaurantsList';

import ApiError from '../entities/ApiError';
import { RestaurantsGroup } from '../entities/restaurantsGroup';
import { ProRolesList, ProRole } from '../entities/security';

class ApiRestaurant {

  static getRestaurantsList(query: Object, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS;

    const requestOptions = {
      endpoint,
      query,
      success: (json: Object) => {
        const restaurantsList: RestaurantsList = new RestaurantsList();
        restaurantsList.fromJson(json);

        success(restaurantsList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRestaurantsListByGeoPt(latitude: string, longitude: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS;

    const requestOptions = {
      endpoint,
      query: {
        latitude,
        longitude,
        loadOrderSettings: false
      },
      success: (json: Object) => {
        const restaurantsList: RestaurantsList = new RestaurantsList();
        restaurantsList.fromJson(json);

        success(restaurantsList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRestaurantsListByGeoPtWithOrderSettings(latitude: string, longitude: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS;

    const requestOptions = {
      endpoint,
      query: {
        // TODO: change when we load order settings via the service
        loadOrderSettings: true,
        latitude,
        longitude
      },
      success: (json: Object) => {
        const restaurantsList: RestaurantsList = new RestaurantsList();
        restaurantsList.fromJson(json);

        success(restaurantsList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }


  static getRestaurant(restaurantId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANT.replace(':restaurantId', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        // TODO: change when we load order settings via the service
        loadOrderSettings: true
      },
      headers: {
        'restaurant-id': restaurantId
      },
      success: (json: Object) => {

        const restaurant: Restaurant = new Restaurant();
        restaurant.fromJson(json);

        success(restaurant);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRestaurantWithDomain(restaurantId: string, domainId, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANT.replace(':restaurantId', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        // TODO: change when we load order settings via the service
        loadOrderSettings: true
      },
      headers: {
        'restaurant-id': restaurantId,
        'pro-domain-id': domainId,
      },
      success: (json: Object) => {

        const restaurant: Restaurant = new Restaurant();
        restaurant.fromJson(json);

        success(restaurant);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRestaurantWithoutOrderSettings(restaurantId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANT.replace(':restaurantId', restaurantId);

    const requestOptions = {
      endpoint,
      query: {
        loadOrderSettings: false
      },
      headers: {
        'restaurant-id': restaurantId
      },
      success: (json: Object) => {

        const restaurant: Restaurant = new Restaurant();
        restaurant.fromJson(json);

        success(restaurant);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRestaurantForGroup(restaurantId: string, restaurantsGroup: RestaurantsGroup, success: Function, failure: Function) {
    ApiRestaurant.getRestaurant(restaurantId,
      (restaurant: Restaurant) => {
        success(restaurant, restaurantsGroup);
      },
      (apiError: ApiError) => {
        failure(apiError);
      }
    );
  }

  /*
  * Update the logged in restaurant.
  *
  * @param restaurant
  */
  static putRestaurantMultipart(restaurantId: string, restaurantMultipart: RestaurantMultipart, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANT.replace(':restaurantId', restaurantId);

    const data = restaurantMultipart.getData();
    const files = restaurantMultipart.getFiles();

    const requestOptions = {
      endpoint,
      data,
      files,
      success: (json: Object) => {
        // -- create restaurant object.
        const restaurant: Restaurant = new Restaurant();
        restaurant.fromJson(json.data);

        success(restaurant);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.putMultipart(requestOptions);
  }

  static postRestaurant(restaurantToPost: Restaurant, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS;

    const requestOptions = {
      endpoint,
      data: restaurantToPost,
      success: (json: Object) => {

        // -- create restaurant object.
        const restaurant: Restaurant = new Restaurant();
        restaurant.fromJson(json);

        success(restaurant);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.post(requestOptions);
  }

}

export default ApiRestaurant;
